import React, { useContext } from 'react';
import { Typography } from 'vindi-ds-components';
import PricingOptions from './pricing_options';
import PricingCards from './pricing_cards';
import { ProductContext } from '../contexts/product_context';

function Pricing() {
  const { params, handleChange } = useContext(ProductContext);
  return (
    <>
      <Typography variant='subtitle1' component='h2' style={{ marginBottom: '1em' }}>
        Precificação
      </Typography>
      <Typography radio variant='subtitle2' component='h3'>
        Selecione o método de cálculo de preço:
      </Typography>
      <PricingCards handleChange={handleChange} activeSchema={params.schema_type} />
      <PricingOptions activeSchema={params.schema_type} />
    </>
  );
}

export default Pricing;
